import http from "./httpService";
import { apiUrl } from "../config.json";
import { getAuthToken } from "./Authentication/AuthService";

const authHeaders = () => ({ "x-access-token": getAuthToken() });

export const getPublicMenu  = () => http.get(`${apiUrl}/menu/public`);
export const getAdminMenu   = () => http.get(`${apiUrl}/menu`, { headers: authHeaders() });
export const updateMenu     = (payload) => http.post(`${apiUrl}/menu/update`, payload, { headers: authHeaders() });
